module.exports = __webpack_public_path__ + "static/media/enrolment.9f34a9fb.png";